<template>
  <div>
    <v-card-text>
      Pro vstup do portálu PREdistribuce, a.s., je potřeba mít platný osobní certifikát
      a zároveň nainstalovanou podpisovou komponentu ve webovém prohlížeči. Ta umožňuje
      <b>elektronický podpis</b>, kterým se přihlásíte do portálu.
      <br>
      {{ msg }}
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        variant="success"
        depressed
        x-large
        color="primary"
        @click="runSign"
        class="px-6"
      >
        Přejít k podpisu
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

    <v-card-text>
      <span id="signingStatus" style="color: red;"></span>
    </v-card-text>

    <v-card-text>
      <ul>
        <li>
          Pokud se komponenta spouští nezvykle dlouho, ověřte, že je nainstalována.
          Instalace je dostupná <a :href="ASDurls.installerUrl" target="_blank">zde</a>.
        </li>
        <li>
          <a :href="ASDurls.helpUrl" target="_blank">Technické požadavky a návod k instalaci</a>.
        </li>
      </ul>
    </v-card-text>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import eventBus from '@/utils/eventBus';

export default {
  name: 'Sign',
  props: {
    signerUrl: String,
  },
  data() {
    return {
      msg: '',
      clientId: 'client',
      ASDurls: {},
    };
  },
  computed: {
    startSignInUrl() {
      return `${this.signerUrl}/signature-session?clientId=${this.clientId}`;
    },
    saveSignatureResultUrl() {
      return `${this.signerUrl}/signature-session-result?sessionId={0}&clientId=${this.clientId}`;
    },
    getLoginSignMessageUrl() {
      return `${this.signerUrl}/signature-content-login`;
    },
  },
  methods: {
    ...mapActions({
      loginAfterSigning: 'auth/loginAfterSigning',
    }),
    runSign() {
      // eslint-disable-next-line
      AsdWebSigner.ClientFasade.startSignatureOutProcess(
        this.startSignInUrl,
        {},
        this.saveSignatureResultUrl,
        'signingStatus',
        null,
        null,
        this.onSaveSignatureResult,
      );
    },
    onSaveSignatureResult(result) {
      // eslint-disable-next-line
      const token = JSON.parse(result);
      this.loginAfterSigning(result);
      this.signing = false;
      this.$router.push({
        name: 'home',
      });
    },
  },
  mounted() {
    axios
      .get(this.getLoginSignMessageUrl)
      // .then((response) => (this.msg = response.data)) // eslint-disable-line
      .catch(() => {
        eventBus.$emit(
          'error500',
          {
            message: 'Selhalo připojení k serveru.',
          },
        );
      });
    //  // eslint-disable-line
    this.$http.get('uaa/sign/clientInfo')
      .then((reponse) => {
        this.ASDurls = reponse.data;
      });
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
}

.v-card__text {
  font-size: 16px;

  li {
    list-style: none;
    position: relative;
    margin-bottom: 5px;

    &::before {
      content: '';
      position: absolute;
      top: 8px;
      left: -24px;
      width: 11px;
      height: 5px;
      border-radius: 4px;
      background: #1c2f67;
    }
  }
}
</style>
